/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FacebookAccountSettings_userSocialNetwork = {|
  +serviceId?: ?string;
  +socialId?: ?string;
  +status?: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FacebookAccountSettings_userSocialNetwork",
  "selections": [
    {
      "kind": "InlineFragment",
      "type": "FacebookSocialNetwork",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "socialId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "status",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "UserSocialNetwork"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/Facebook/__generated__/FacebookAccountSettings_userSocialNetwork.graphql.js